<template>
  <div>
    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">Pregled ruta teretnih vozila</h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium">
      <ul>
        <li :class="{ 'is-active': this.tabSelector === 0 }">
          <a @click="tabClicked(0)">Danas</a>
        </li>
        <li v-bind:class="{ 'is-active': this.tabSelector === 1 }">
          <a @click="tabClicked(1)">Juče</a>
        </li>
        <li :class="{ 'is-active': this.tabSelector === 2 }">
          <a @click="tabClicked(2)">Proizvoljan period</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content" v-show="this.tabSelector === 2">
      <date-picker v-model="time3" @input="timeSpanChosen" range></date-picker>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium">
      <ul>
        <li :class="{ 'is-active': this.sortTabSelector === 0 }">
          <a @click="sortTabClicked(0)">Po vozaču</a>
        </li>
        <li v-bind:class="{ 'is-active': this.sortTabSelector === 1 }">
          <a @click="sortTabClicked(1)">Po vozilu</a>
        </li>
      </ul>
    </div>

    <!-- Table -->
    <div class="base-demo">
      <vue-table-dynamic
        class="small"
        :params="params"
        ref="table"
        @cell-click="tableCellClicked"
        @cell-change="onCellChange"
      ></vue-table-dynamic>
    </div>
  </div>
</template>

<script>
import ReportService from "../../services/report.service";
import VueTableDynamic from "vue-table-dynamic-sum";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { maskIfEquealsValue } from "../../_helpers/arrangers";
import { colors } from "../../_helpers/colors";

export default {
  name: "RouteReport",
  components: {
    VueTableDynamic,
    DatePicker,
  },
  data() {
    return {
      //   monthChosen
      time3: null,
      firstDay: null,
      lastDay: null,
      selectedMonth: 0,
      selectedYear: 0,
      tabSelector: 0,
      sortTabSelector: 0,
      employees: [],
      employeeIdsBeenOnRoute: [],
      freightVehicles: [],
      rawData: [],
      params: {
        data: [
          [
            "Ndx",
            "Vozilo",
            "Broj tura",
            "Pređeno km",
            "BD-TV",
            "KO-HN",
            "PE-UL",
            "NK",
            "Sjever",
            "Lokal",
            "Ispor. dr. vozača",
            "Druga tura",
            "Titex",
            "Povrat",
            "Ostala zapažanja",
          ],
        ],
        header: "row",
        enableSearch: false,
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: "3%" },
          { column: 1, width: "12%" },
          { column: 2, width: "10%" },
          { column: 15, width: "12%" },
        ],
        edit: {
          column: [-1, -2],
        },
        wordWrap: "break-word",
        whiteSpace: "normal",
        highlight: { row: [-1] },
        highlightedColor: colors[6],
        sumIncludeInSearch: true,
        sumSecretPhrase: "Σ",
        sumColumns: [
          { column: 2, type: "decimal" },
          { column: 3, type: "decimal" },
          { column: 4, type: "decimal" },
          { column: 5, type: "decimal" },
          { column: 6, type: "decimal" },
          { column: 7, type: "decimal" },
          { column: 8, type: "decimal" },
          { column: 9, type: "decimal" },
          { column: 10, type: "decimal" },
          { column: 11, type: "decimal" },
          { column: 12, type: "decimal" },
        ],
      },
      departments: [],
      seletedDepartment: null,
    };
  },
  mounted() {
    this.time3 = new Date();
    this.tabClicked(1);
    // this.getDepartments();
  },
  methods: {
    tableCellClicked() {},

    resetUi() {
      this.params.data = [
        [
          "Ndx",
          "Vozač/Vozilo",
          "Broj tura",
          "Pređeno km",
          "BD-TV",
          "KO-HN",
          "PE-UL",
          "NK",
          "Sjever",
          "Lokal",
          "Ispomoć",
          "Druga tura",
          "Titex",
          "Povrat",
          "Ostala zapažanja",
        ],
      ];
      this.dailyLogs = [];
      this.rawData = [];
      this.employeeIdsBeenOnRoute = [];
    },

    async getDepartments() {
      let totalValue = new Array(14).fill(0);

      // load data
      let report = await ReportService.GetGroupedRouteLogsForTimeSpan(
        this.firstDay,
        this.lastDay
      );

      console.log("report data: ", report.data);

      let ndx = 0;

      if (this.sortTabSelector == 0) {
        // By driver

        // First class data
        report.data.orderedDriverFreightLogs.forEach((fv) => {
          console.log(fv);

          totalValue[0] += fv.tourCount;
          totalValue[1] += fv.kilometerSpent;
          totalValue[2] += fv.bdtvCount;
          totalValue[3] += fv.kohnCount;
          totalValue[4] += fv.peulCount;
          totalValue[5] += fv.nkCount;
          totalValue[6] += fv.sjeverCount;
          totalValue[7] += fv.lokalCount;
          totalValue[8] += fv.ispomocCount;
          totalValue[9] += fv.drugaTuraCount;
          totalValue[10] += fv.titexCount;

          this.params.data.push([
            ++ndx,
            fv.driverName,
            maskIfEquealsValue(fv.tourCount, "0"),
            maskIfEquealsValue(fv.kilometerSpent / 1000, "0"),
            maskIfEquealsValue(fv.bdtvCount, "0"),
            maskIfEquealsValue(fv.kohnCount, "0"),
            maskIfEquealsValue(fv.peulCount, "0"),
            maskIfEquealsValue(fv.nkCount, "0"),
            maskIfEquealsValue(fv.sjeverCount, "0"),
            maskIfEquealsValue(fv.lokalCount, "0"),
            maskIfEquealsValue(fv.ispomocCount, "0"),
            maskIfEquealsValue(fv.drugaTuraCount, "0"),
            maskIfEquealsValue(fv.titexCount, "0"),
            maskIfEquealsValue(fv.povrat, "0"),
            maskIfEquealsValue(fv.comment, "0"),
          ]);

          // Second class data
          fv.vehicleFreightReports.forEach((vf) => {
            this.params.data.push([
              "",
              vf.vehicleModel,
              maskIfEquealsValue(vf.tourCount, "0"),
              maskIfEquealsValue(vf.kilometerSpent / 1000, "0"),
              maskIfEquealsValue(vf.bdtvCount, "0"),
              maskIfEquealsValue(vf.kohnCount, "0"),
              maskIfEquealsValue(vf.peulCount, "0"),
              maskIfEquealsValue(vf.nkCount, "0"),
              maskIfEquealsValue(vf.sjeverCount, "0"),
              maskIfEquealsValue(vf.lokalCount, "0"),
              maskIfEquealsValue(vf.ispomocCount, "0"),
              maskIfEquealsValue(vf.drugaTuraCount, "0"),
              maskIfEquealsValue(vf.titexCount, "0"),
              maskIfEquealsValue(vf.povrat, "0"),
              maskIfEquealsValue(vf.comment, "0"),
            ]);
          });
        });

        // push last row
        this.params.data.push([
          "",
          "Σ (za vremenski raspon)",
          maskIfEquealsValue(totalValue[0].toFixed(2), "0.00"),
          maskIfEquealsValue((totalValue[1] / 1000).toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[2].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[3].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[4].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[5].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[6].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[7].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[8].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[9].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[10].toFixed(2), "0.00"),
          "",
          "",
        ]);
      } else if (this.sortTabSelector == 1) {
        // By vehicle
        console.log("PAPAGAJA");

        // First class data
        report.data.orderedVehicleFreightLogs.forEach((fv) => {
          console.log(fv);

          totalValue[0] += fv.tourCount;
          totalValue[1] += fv.kilometerSpent;
          totalValue[2] += fv.bdtvCount;
          totalValue[3] += fv.kohnCount;
          totalValue[4] += fv.peulCount;
          totalValue[5] += fv.nkCount;
          totalValue[6] += fv.sjeverCount;
          totalValue[7] += fv.lokalCount;
          totalValue[8] += fv.ispomocCount;
          totalValue[9] += fv.drugaTuraCount;
          totalValue[10] += fv.titexCount;

          this.params.data.push([
            ++ndx,
            fv.vehicleModel,
            maskIfEquealsValue(fv.tourCount, "0"),
            maskIfEquealsValue(fv.kilometerSpent / 1000, "0"),
            maskIfEquealsValue(fv.bdtvCount, "0"),
            maskIfEquealsValue(fv.kohnCount, "0"),
            maskIfEquealsValue(fv.peulCount, "0"),
            maskIfEquealsValue(fv.nkCount, "0"),
            maskIfEquealsValue(fv.sjeverCount, "0"),
            maskIfEquealsValue(fv.lokalCount, "0"),
            maskIfEquealsValue(fv.ispomocCount, "0"),
            maskIfEquealsValue(fv.drugaTuraCount, "0"),
            maskIfEquealsValue(fv.titexCount, "0"),
            maskIfEquealsValue(fv.povrat, "0"),
            maskIfEquealsValue(fv.comment, "0"),
          ]);

          // Second class data
          fv.driverFreightReports.forEach((vf) => {
            this.params.data.push([
              "",
              vf.driverName,
              maskIfEquealsValue(vf.tourCount, "0"),
              maskIfEquealsValue(vf.kilometerSpent / 1000, "0"),
              maskIfEquealsValue(vf.bdtvCount, "0"),
              maskIfEquealsValue(vf.kohnCount, "0"),
              maskIfEquealsValue(vf.peulCount, "0"),
              maskIfEquealsValue(vf.nkCount, "0"),
              maskIfEquealsValue(vf.sjeverCount, "0"),
              maskIfEquealsValue(vf.lokalCount, "0"),
              maskIfEquealsValue(vf.ispomocCount, "0"),
              maskIfEquealsValue(vf.drugaTuraCount, "0"),
              maskIfEquealsValue(vf.titexCount, "0"),
              maskIfEquealsValue(vf.povrat, "0"),
              maskIfEquealsValue(vf.comment, "0"),
            ]);
          });
        });

        // push last row
        this.params.data.push([
          "",
          "Σ (za vremenski raspon)",
          maskIfEquealsValue(totalValue[0].toFixed(2), "0.00"),
          maskIfEquealsValue((totalValue[1] / 1000).toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[2].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[3].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[4].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[5].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[6].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[7].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[8].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[9].toFixed(2), "0.00"),
          maskIfEquealsValue(totalValue[10].toFixed(2), "0.00"),
          "",
          "",
        ]);
      }
    },

    sortTabClicked(value) {
      this.sortTabSelector = value;
      this.tabClicked(this.tabSelector);
    },

    tabClicked(value) {
      this.tabSelector = value;
      if (value === 0) {
        let yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
        let today = new Date();
        yesterday.setHours(24, 0, 0, 0);
        today.setHours(24, 0, 0, 0);
        this.firstDay = yesterday;
        this.lastDay = today;
        this.resetUi();
        this.getDepartments();
      } else if (value === 1) {
        let dayBeforeYesterday = new Date(
          new Date().setDate(new Date().getDate() - 2)
        );
        let yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
        this.firstDay = dayBeforeYesterday;
        yesterday.setHours(24, 0, 0, 0);
        dayBeforeYesterday.setHours(24, 0, 0, 0);
        this.lastDay = yesterday;
        this.resetUi();
        this.getDepartments();
      } else if (value === 2) {
        if (this.firstDay != null && this.lastDay != null) {
          console.log("PAJA");
          console.log(this.firstDay);
          console.log(this.lastDay);
          console.log(this.time3);
          this.resetUi();
          this.getDepartments();
        }
        // this.firstDay = null;
        // this.lastDay = null;
        // this.resetUi();
      }
      // this.resetUi();
      this.selectedEmployee = null;
    },

    timeSpanChosen(span) {
      if (span[0] == null || span[1] == null) {
        return;
      }
      this.firstDay = span[0];
      this.lastDay = span[1];
      this.resetUi();
      this.getDepartments();
    },

    onCellChange(rowIndex, columnIndex, data) {
      console.log("onCellChange: ", rowIndex, columnIndex, data);
      console.log("table data: ", this.$refs.table.getData());
    },
  },
};
</script>

<style scoped>
.small {
  font-size: 11px;
}
</style>
